import { createStore, combineReducers } from 'redux';
import createLogger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import rootSaga from '../sagas';

const sagaMiddleware = createSagaMiddleware();
const logger = createLogger();
export default function configureStore({reducer, stateKey, applyMiddleware, sagas}) {
  if(stateKey){
    reducer = combineReducers({
      [stateKey]: reducer
    })
  }
  const store = createStore(
    reducer,
    {},
    applyMiddleware(sagaMiddleware)
  );
  sagaMiddleware.run(rootSaga(store.getState, sagas));

  const middlewareAPI = {
    getState: store.getFullState,
    dispatch: store.dispatch,
  };
  const log = logger(middlewareAPI)(()=>{});
  store.onEvent('rootDispatch', (action)=>{
    log(action);
  });
  // if (module.hot) {
  //   // Enable Webpack hot module replacement for reducers
  //   module.hot.accept('../reducers', () => {
  //     const nextRootReducer = reducer.default;
  //
  //     store.replaceReducer(nextRootReducer);
  //   });
  // }

  return store;
}



// WEBPACK FOOTER //
// ./src/app/state/store/configureStore.dev.js